module.exports = __webpack_public_path__ + "img/misc-banner.5f82d41b.jpg";